module.exports = __webpack_public_path__ + "img/bzq.98c93a93.png";